import { Auth0Provider } from "@auth0/auth0-react";
import { CssBaseline, DriftThemeProvider } from "drift-ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import config from "./config";
import { ForthLeafErrorBoundary } from "./forthLeafErrorBoundary";
import { restoreReturnPath } from "./forthLeafNavigation";
import { router } from "./forthLeafRouter";
import "./index.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Forth Leaf root element was not found.");
}

createRoot(root).render(
  <StrictMode>
    <DriftThemeProvider>
      <CssBaseline />
      <Auth0Provider
        authorizationParams={{
          audience: `https://${config.auth0Domain}/api/v2/`,
          redirect_uri: window.location.origin,
          scope: "openid profile email offline_access",
        }}
        clientId={config.auth0ClientId}
        domain={config.auth0CustomDomain}
        onRedirectCallback={(appState) => {
          // Router navigation continues after Auth0 finishes handling the callback.
          void router.navigate({
            replace: true,
            to: restoreReturnPath(router, appState?.returnTo),
          });
        }}
      >
        <ForthLeafErrorBoundary>
          <App />
        </ForthLeafErrorBoundary>
      </Auth0Provider>
    </DriftThemeProvider>
  </StrictMode>,
);
